import { defineComponent } from '@vue/composition-api';
import PerfOverlay from './Overlay.ts.vue';
export default defineComponent({
    name: 'DpPerf',
    components: {
        PerfOverlay,
    },
    setup() {
        return {};
    },
});
